/** Feature id used by both apps when branching from navigation / resolver output. */
export const SEND_ALERT_FEATURE_ID = "sendAlert" as const;

/** Stakeholder codes aligned with legacy `constants.string` (Buxus API values). */
export const STAKEHOLDER_GROUP_ALL = "ALL";
export const STAKEHOLDER_GROUP_ALL_RESPONDERS = "ALL_RESPONDERS";

const STAKEHOLDER_EMERGENCY_RESPONDER = "ER - Emergency Responder";
const STAKEHOLDER_COMMANDER = "EC - Commander";
const STAKEHOLDER_TIER_II = "ET - Tier II";
const STAKEHOLDER_EXCAVATOR = "EX - Excavator";
const STAKEHOLDER_FARMER = "FM - Farmer";
const STAKEHOLDER_PUBLIC_OFFICIAL = "PO - Public Official";
const STAKEHOLDER_AFFECTED_PUBLIC = "AP - Affected Public";
const STAKEHOLDER_SCHOOL_REP = "SC - School Rep";
const STAKEHOLDER_OTHER = "OT - Other";

export const ALL_STAKEHOLDER_TYPES = [
  STAKEHOLDER_EMERGENCY_RESPONDER,
  STAKEHOLDER_COMMANDER,
  STAKEHOLDER_TIER_II,
  STAKEHOLDER_EXCAVATOR,
  STAKEHOLDER_FARMER,
  STAKEHOLDER_PUBLIC_OFFICIAL,
  STAKEHOLDER_AFFECTED_PUBLIC,
  STAKEHOLDER_SCHOOL_REP,
  STAKEHOLDER_OTHER,
] as const;

export const RESPONDER_STAKEHOLDER_TYPES = [
  STAKEHOLDER_TIER_II,
  STAKEHOLDER_COMMANDER,
  STAKEHOLDER_EMERGENCY_RESPONDER,
] as const;

export const ALERT_DELIVERY_TYPE_ALL = "ALL";
export const ALERT_DELIVERY_TYPE_EMAIL = "EMAIL";
export const ALERT_DELIVERY_TYPE_SMS = "SMS";
export const ALERT_DELIVERY_TYPE_VOICE = "VOICE";

export const SEND_ALERT_DEFAULT_MESSAGE = "TEST ALERT (please disregard if received)";
export const ALERT_SUCCESS_MESSAGE = "Alert sent successfully";

export type SendAlertSelectId =
  | "stakeholderType"
  | "country"
  | "state"
  | "county"
  | "deliveryType";

export type SendAlertResolvedField =
  | {
      kind: "select";
      id: SendAlertSelectId;
      label: string;
      placeholder: string;
      required: true;
    }
  | {
      kind: "textarea";
      id: "message";
      label: string;
      placeholder: string;
      required: true;
      defaultValue: string;
    }
  | {
      kind: "text";
      id: "title";
      label: string;
      placeholder: string;
      required: false;
    };

/** Field ids used in `sections` layout. Optional `title` may be omitted while hidden but remains in `fields`. */
export type SendAlertSectionFieldId = SendAlertSelectId | "message" | "title";

export type SendAlertScreenResolved = {
  featureId: typeof SEND_ALERT_FEATURE_ID;
  title: string;
  /** Static option lists; state/county options come from `COUNTIES_BY_COUNTRY` + helpers. */
  stakeholderOptions: { label: string; value: string }[];
  countryOptions: { label: string; value: string }[];
  deliveryOptions: { label: string; value: string }[];
  /** Declarative layout: each section lists field ids in display order. */
  sections: { heading: string; fieldIds: SendAlertSectionFieldId[] }[];
  fields: SendAlertResolvedField[];
  strings: {
    continueCta: string;
    sendCta: string;
    previewHeading: string;
    requiredBanner: string;
    successMessage: string;
  };
};

function stakeholderDisplayLabel(code: string): string {
  return code.replace(/^[\w]{2} - /, "");
}

export function buildStakeholderSelectOptions(): { label: string; value: string }[] {
  return [
    { label: "All Stakeholders", value: STAKEHOLDER_GROUP_ALL },
    { label: "All Responders", value: STAKEHOLDER_GROUP_ALL_RESPONDERS },
    ...ALL_STAKEHOLDER_TYPES.map((x) => ({
      label: stakeholderDisplayLabel(x),
      value: x,
    })),
  ];
}
